/* Verediana Trinity Elixir — Theme JS
   Production-ready · Performance optimised */

(function () {
  'use strict';

  // ── Announcement bar rotation ──────────────────────────────
  var msgs = document.querySelectorAll('.announce-msg');
  if (msgs.length > 1) {
    var current = 0;
    msgs[current].classList.add('active');
    setInterval(function () {
      msgs[current].classList.remove('active');
      current = (current + 1) % msgs.length;
      msgs[current].classList.add('active');
    }, 4000);
  } else if (msgs.length === 1) {
    msgs[0].classList.add('active');
  }

  // ── Sticky header with dark/light state ─────────────────────
  var header = document.querySelector('.site-header');
  if (header) {
    var hero = document.querySelector('.hero') || document.querySelector('.pdp-hero');
    if (hero) {
      header.classList.add('site-header--dark');
      var heroBottom = function () { return hero.getBoundingClientRect().bottom; };
      var updateHeader = function () {
        var hb = heroBottom();
        if (hb > 120) {
          header.classList.add('site-header--dark');
          header.classList.remove('scrolled');
        } else {
          header.classList.remove('site-header--dark');
          header.classList.add('scrolled');
        }
      };
      window.addEventListener('scroll', updateHeader, { passive: true });
      updateHeader();
    } else {
      // No hero — fall back to simple scroll toggle
      var onScroll = function () {
        header.classList.toggle('scrolled', window.scrollY > 40);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  // ── Scroll reveal (IntersectionObserver) ───────────────────
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  }

  // ── Parallax disabled per user request ─────────────────────

  // ── Mobile menu ────────────────────────────────────────────
  var toggle = document.querySelector('.menu-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.classList.contains('open');
      mobileNav.classList.toggle('open', !open);
      toggle.setAttribute('aria-expanded', String(!open));
      document.body.style.overflow = open ? '' : 'hidden';
    });
    // Close on overlay click
    mobileNav.addEventListener('click', function (e) {
      if (e.target === mobileNav) {
        mobileNav.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  // ── Gallery thumbnails ─────────────────────────────────────
  document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var container = thumb.closest('[class*="gallery"], [class*="pdp-main"]');
      if (!container) return;
      var main = container.querySelector('.pdp-main__image-primary img, .gallery-main img');
      if (main && thumb.querySelector('img')) {
        var newSrc = thumb.querySelector('img').src.replace(/width=\d+/, 'width=900');
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = newSrc;
          main.style.opacity = '1';
        }, 200);
      }
      container.querySelectorAll('.gallery-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // ── Smooth anchor links ────────────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id === '#') return;
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        var offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announce-h') || '0', 10) + 72;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  // ── Accordion ──────────────────────────────────────────────
  document.querySelectorAll('.accordion-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.accordion-item');
      if (item) item.classList.toggle('open');
    });
  });

  // ── Back-in-stock notify toggle ────────────────────────────
  document.querySelectorAll('[data-notify-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var formEl = btn.closest('.pdp-main__actions') ? btn.parentElement.querySelector('.pdp-main__notify-form') : null;
      if (!formEl) formEl = btn.nextElementSibling;
      if (!formEl) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      formEl.hidden = open;
      formEl.setAttribute('aria-hidden', String(open));
      if (!open) {
        var emailInput = formEl.querySelector('input[type="email"]');
        if (emailInput) emailInput.focus();
      }
    });
  });

  // ── Sticky add-to-bag bar (PDP) ─────────────────────────────
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var mainActions = document.querySelector('.pdp-main__actions');
  if (stickyAtc && mainActions) {
    var atcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyAtc.classList.toggle('visible', show);
        stickyAtc.setAttribute('aria-hidden', String(!show));
      });
    }, { threshold: 0 });
    atcObserver.observe(mainActions);
  }

  // ── Hero video: pause when not visible ─────────────────────
  var heroVideo = document.querySelector('.hero-bg__video');
  if (heroVideo) {
    var videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          heroVideo.play().catch(function () {});
        } else {
          heroVideo.pause();
        }
      });
    }, { threshold: 0.1 });
    videoObserver.observe(heroVideo);
  }

  // ── Cursor glow with lerp (desktop only) ────────────────────
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var glow = document.createElement('div');
    glow.className = 'cursor-glow';
    document.body.appendChild(glow);
    var mx = 0, my = 0, cx = 0, cy = 0;
    document.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; });
    (function animGlow() {
      cx += (mx - cx) * 0.08;
      cy += (my - cy) * 0.08;
      glow.style.left = cx + 'px';
      glow.style.top = cy + 'px';
      requestAnimationFrame(animGlow);
    })();
  }

  // ── Lazy load images that are offscreen ────────────────────
  if ('loading' in HTMLImageElement.prototype) {
    // Browser supports native lazy loading — nothing extra needed
  } else {
    // Fallback: use IntersectionObserver for lazy loading
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    if (lazyImages.length) {
      var lazyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
            }
            lazyObserver.unobserve(img);
          }
        });
      });
      lazyImages.forEach(function (img) { lazyObserver.observe(img); });
    }
  }

})();
